module.exports = __webpack_public_path__ + "static/media/collab-brainstorm.740ac720.png";